import React from 'react'

import PropTypes from 'prop-types'

import { useConsentConfig } from 'components/ConsentConfigProvider'

import Banner from '../Banner'
import Modal from '../Modal'


export default function ConsentPromptLayout({ ariaLabel, messageComponent }) {
  const consentConfig = useConsentConfig()

  const Layout = ( consentConfig.display_style === 'modal' ) ? Modal : Banner

  return (
    <Layout
      ariaLabel={ ariaLabel }
      messageComponent={ messageComponent }
    />
  )
}

ConsentPromptLayout.propTypes = {
  messageComponent: PropTypes.elementType.isRequired,

  ariaLabel: PropTypes.string,
}
